import { groupKitControllerUpsertDefaultRepositoryKit } from "@/lib/gen-api";
import { queryKeys } from "@/lib/query-keys";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useGroupData } from "./use-groups-data";
import { useKitData } from "./use-kits-data";

const migrationState = new Map<string, boolean>();

export const useGroupRepositoryKitData = (groupUuid: string | null) => {
  const { group, isLoading: isLoadingGroup } = useGroupData(groupUuid);
  const { kit, isLoading: isLoadingKit } = useKitData(
    groupUuid,
    group?.repositoryKitUuid ?? null,
  );

  const queryClient = useQueryClient();

  // Create default repository kit if not present
  useEffect(() => {
    // Guarantee we run this only once per group
    const isAlreadyInitiated = groupUuid
      ? migrationState.get(groupUuid)
      : false;

    if (isAlreadyInitiated) return;
    if (!groupUuid || isLoadingGroup) return;
    if (group && group.repositoryKitUuid) return;

    migrationState.set(groupUuid, true);

    groupKitControllerUpsertDefaultRepositoryKit({
      path: {
        groupUuid,
      },
    }).then(() => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.kits(groupUuid!),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.group(groupUuid!),
      });
    });
  }, [isLoadingGroup, groupUuid]);

  return {
    isLoading:
      isLoadingGroup ||
      (isLoadingKit && group !== null && group.repositoryKitUuid !== null),
    kit: kit,
  };
};
